import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=88b44ef0"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b44ef0')) {
      api.createRecord('88b44ef0', component.options)
    } else {
      api.reload('88b44ef0', component.options)
    }
    module.hot.accept("./RouteView.vue?vue&type=template&id=88b44ef0", function () {
      api.rerender('88b44ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/RouteView.vue"
export default component.exports